import { Injectable, inject } from '@angular/core';
import { EStorageKeys } from '../enums/storage-keys.enum';
import { StorageService } from './storage.service';

/**
 * Remembers the selection of a list page's multi-select filter (status, Werk, …) in localStorage,
 * so it survives navigating away and back.
 */
@Injectable({
  providedIn: 'root',
})
export class FilterStorageService {
  private readonly storageService = inject(StorageService);

  /**
   * The stored selection, reduced to values that are still in `allowed` — stale or tampered
   * entries are dropped. Empty when nothing (or nothing valid) is stored.
   */
  public restore<T extends string>(key: EStorageKeys, allowed: readonly T[]): T[] {
    const stored: unknown = this.storageService.getItem(key);
    if (!Array.isArray(stored)) return [];

    return stored.filter((value: unknown): value is T => allowed.includes(value as T));
  }

  public persist<T extends string>(key: EStorageKeys, values: readonly T[]): void {
    try {
      this.storageService.setItem(key, values);
    } catch {
      // Ignore storage failures (quota/private mode)
    }
  }
}
